import { useField, useFormikContext } from 'formik';

import type { VesselMessage } from '../../types/VesselMessage';

import { VesselSelect } from './VesselSelect';
import type { VesselSelectProps } from './VesselSelect';

interface FormikVesselSelectProps extends Omit<VesselSelectProps, 'vesselId' | 'onChange'> {
    name: string;
    onVesselSelect?: (vessel: VesselMessage | null) => void;
}

export const FormikVesselSelect = ({ name, onVesselSelect, caption, ...props }: FormikVesselSelectProps) => {
    const [field, meta, helpers] = useField<string | null>(name);
    const { validateOnChange } = useFormikContext();

    const handleChange = (vessel: VesselMessage | null) => {
        helpers.setValue(vessel?.id ?? null);
        onVesselSelect?.(vessel);

        if (!validateOnChange && meta.error) {
            helpers.setError(undefined);
        }
    };

    return (
        <VesselSelect
            {...props}
            vesselId={field.value}
            onChange={handleChange}
            negative={meta.touched && !!meta.error}
            caption={meta.touched && meta.error ? meta.error : caption}
            onBlur={() => helpers.setTouched(true)}
        />
    );
};
